import { FelaCSS } from '../../../../components/fela/flowtypes';
import { SharedTypes as PropTypes } from './radio-toggle-wrap';

interface StypeTypes {
  wrapper: FelaCSS;
  input: FelaCSS;
  label: FelaCSS;
}

const styles = ({ disabled, block }: PropTypes): StypeTypes => ({
  wrapper: {
    position: 'relative',
    display: block ? 'flex' : 'inline-flex',
    width: block ? '100%' : 'auto',
  },

  input: {
    position: 'absolute',
    visibility: 'hidden',
  },

  label: disabled
    ? {
        pointerEvents: 'none',
        cursor: 'default',
      }
    : {
        cursor: 'pointer',
      },
});

export default styles;
